import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { TrackObject } from '../asp/TrackObject';
import * as aro from '@core_n/aro/aro';
import { SensorCoreObject } from '../../core/app/asp/SensorCoreObject';
import { mainMapMngr, MapMngr } from '../../core/app/asp/MapMngr';
import * as aspObjects from '../../core/app/asp/aspObjects';
import * as aspSettings from '../../core/app/asp/aspSettings';
import { AroSensorService } from '../aro/aro-sensor.service';
import { AppInjector } from '@core_n/common/inject';
import { SensorObject } from '../asp/SensorObject';
import { TrackType } from '@core_n/common/enums';

@Component({
  templateUrl: 'aro-track-tab-gen.component.html',
  styleUrls: ['../../core/app/aro/aro.component.scss'],
})
export class AroTrackTabGenComponent implements OnInit {
  // Classification
  public systemClass: number = 0;
  public operatorClass: number = 0;
  public fighter: number = 0;
  public helicopter: number = 0;
  public subsonicMissile: number = 0;
  public supersonicMissile: number = 0;
  public transporter: number = 0;
  public uav: number = 0;

  // Corrolated Sensors
  // public corrSensorsData: Array<any> = [];
  // public corrSensorsColumns: string[] = ['sic', 'sac', 'letter', 'id'];
  // public corrSensorsDataSource = new MatTableDataSource(this.corrSensorsData);
  // @ViewChild('corrSensorsTable', { read: MatSort, static: true }) corrSensorsSort: MatSort;

  constructor() {
  }

  ngOnInit(): void {
    // this.corrSensorsDataSource.sort = this.corrSensorsSort;
  }

  refresh(track: TrackObject): void {
    // this.systemClass = track.systemClass;
    // this.operatorClass = track.operatorClass;
    // this.fighter = track.idfFighter;
    // this.helicopter = track.idfHelicopter;
    // this.subsonicMissile = track.idfSubsonicMissile;
    // this.supersonicMissile = track.idfSupersonicMissile;
    // this.transporter = track.idfTransporter;
    // this.uav = track.idfUav;
    
    // this.corrSensorsData = [];
    // for (let corrSensor of track.snsObjList)
    //   this.corrSensorsData.push({ sic: corrSensor.sic, sac: corrSensor.sac, letter: corrSensor.sensorLetter, id: corrSensor.sensorID });
    // this.corrSensorsDataSource.data = this.corrSensorsData;
  }
}
